// @ts-check
// @ts-ignore

import {
  COLLECT_TYPE_NONE, PAY_TIMING_HIMEFIX, PAY_TYPE_STAFF_DRIVER, RECV_METHOD_HAND,
  RECV_TIMING_HIMEFIX_RESV_PAYVIEW, RECV_TYPE_DRIVER_STAFF
} from '@/common/constants/money';
import * as ResvItem from '@/common/constants/resv-item';
import { TARGETINPUT_NONE } from '@/common/constants/schedule';
import * as UserExtItem from '@/common/constants/user-ext-item';
import { SBTYPE_SPEC } from './constants/office';
import { SMS_TYPE_NOREPLY, TYPE_CALL, TYPE_TIME } from './constants/act-resv';
import { deepFreeze } from './utils/objects';
import { HIME_CONTACT_LINE, HIME_CONTACT_LINE_SIMPLE, HIME_CONTACT_MAIL } from './constants/hime';
import { USER_CONTACT_SMS } from './constants/notify';
import { DISPLAY_NAME_REAL, DISPLAY_SHOW } from './constants/pay';
export const DEMO_DEV_ID = 'demo_dev';
export const DEMO_ID = 'demo';
export const DEMO_DATE = '20211030';
export const baseColor = '#3f51b5';
export const DEMO_UNIX = 1635577200000;

/** Owner > User */
export const clsList = ['5', ['0', '一般', true], ['1', '会員', true], ['2', '常連', true], ['3', 'VIP', true], ['4', 'NG', true]];

export const likingList = ['C',
  ['0', '素人', true], ['1', 'セクシー系', true], ['2', '熟女系', true], '<br>',
  ['3', 'ぽっちゃり系', true], ['4', '美乳', true], ['5', '微乳', true], '<br>',
  ['6', '巨乳', true], ['7', '美脚', true], ['8', '黒髪', true], ['9', '金髪', true], '<br>',
  ['A', '外国人', true], ['B', 'ニューハーフ', true]
];

export const extList = [
  {
    'dataIdx': 1, 'use': true, 'viewType': UserExtItem.VIEWTYPE_SELECT, 'viewWidth': 1, 'label': '年齢',
    'selectList': ['7', ['1', '20代', true], ['2', '30代', true], ['3', '40代', true], ['4', '50代', true], ['5', '60代', true], ['6', '70代', true]]
  },
  {
    'dataIdx': 2, 'use': true, 'viewType': UserExtItem.VIEWTYPE_SELECT_EDIT, 'viewWidth': 1, 'label': '交通手段',
    'selectList': ['6', ['1', '電車', true], ['2', '自家用車', true], ['3', 'タクシー', true], ['4', '徒歩', true], ['5', 'その他', true]]
  }
];

/** Office > Mail */
export const smsCheckCount = 199;

export const useBiSmsResv = false;

export const useBiSmsWeb = true;

export const userContactType = USER_CONTACT_SMS;

/** Office > Basic */
export const btStart = 600; //10時

export const btEnd = 1560; //翌2時

export const viewPrice = 4; //12万3456円

export const globalCalc = '<%\nfunction isWrittenDiary($hd) {\nif($hd && $hd.data["写メ日記"]=="写メ500"){\n\treturn true;\n      } \nif($hd && $hd.data["写メ日記"]=="写メ1000"){\n\treturn true;\n      }   \nif($hd && $hd.data["写メ日記"]=="写メ1500"){\n\treturn true;\n      }   \n      return false;\n}\n%>';

export const hotelMode20260310 = 'legacy'; //2026/03/10以前のホテルモード
export const hotelMode = 'new'; //2026/03/10以降のホテルモード

/** Office > Hime */
export const himePropList = ['D',
  ['HON', '本名', '本名', '#D5EAFF'],
  ['0', 'かわいい系', 'ｶﾜｲｲ', '#FFD5D5'], ['1', 'キレイ系', 'ｷﾚｲ', '#FFFFD5'],
  ['2', 'モデル系', 'ﾓﾃﾞﾙ', '#D5EAFF'], ['3', '素人', '素人', '#D5FFD5'],
  ['4', '美乳', '美乳', '#FFFFD5'], ['5', '美脚', '美脚', '#FFFFD5'],
  ['6', '明るい', '明', '#FFD5D5'], ['7', '人懐っこい', '人懐', '#FFD5D5'],
  ['8', '癒し系', '癒', '#D5FFD5'],
  ['9', 'エロい', 'ｴﾛ', '#FFD5D5'], ['A', '喫煙しない', '非喫煙', '#D5FFD5'],
  ['B', '女子大生', 'JD', '#FFD5AA'], ['C', '人妻', '人妻', '#FFD5AA'],
];

export const himeOrder = '1';//出勤時間順
export const hdStateNotConfirm = 60;
export const hdStateMoveResv = 1;
export const hdStateListList = [
  [1, '出勤状態', true, 7,
    [0, '出勤確認前', '', '#FFD5AA', true],
    [0, '出勤確認なし', '出確なし', '#FF8080', true],
    [1, '出勤確認済', '出確済', '#D5EAFF', true],
    [3, '出勤', '出勤', '#D5FFD5', true],
    [4, '出勤終了', '終了', '#E6E6E6', true],
    [5, 'お休み', 'お休み', '#E6E6E6', true],
    [6, '当日欠勤', '当欠', '#E6E6E6', true]
  ],
  [2, '帰宅前確認', true, 1, [0, 'シフト要請', 'ｼﾌﾄ要請', '#FFD5AA']]
];

export const hdWorkTargetPlaceList = [4,
  [1, '場所A', '新宿区高田馬場1-XX-XX ダミーマンション201', '35.71381120422601, 139.70394181082762', '#000000', true],
  [2, '場所B', '新宿区高田馬場1-XX-XX ダミーマンション202', '35.71381120422601, 139.70394181082762', '#000000', true],
  [3, '場所C', '新宿区高田馬場1-XX-XX ダミーマンション203', '35.71381120422601, 139.70394181082762', '#000000', true]
];

export const driverPlaceList = [0];

export const hdDataListList = [
  [1, '写メ日記', 4, [1, '写メ500', '写メ500', '#D5D5FF'], [2, '写メ1000', '写メ1000', '#80BFFF'], [3, '写メ1500', '写メ1500', '#3D85C6']],
  [2, '遅刻・早退', 3, [1, '遅刻', '遅刻', '#ccc'], [2, '早退', '早退', '#ccc']],
  [3, '待機場所', 4,
    [1, '場所A', '場所A', '区高田馬場1-XX-XX ダミーマンション201', '区高田馬場1-XX-XX ダミーマンション201', '#cccccc'],
    [2, '場所B', '場所B', '区高田馬場1-XX-XX ダミーマンション201', '区高田馬場1-XX-XX ダミーマンション201', '#cccccc'],
    [3, '場所C', '場所C', '区高田馬場1-XX-XX ダミーマンション201', '区高田馬場1-XX-XX ダミーマンション201', '#cccccc'], 3
  ]
];

export const hdStateEnd = [4, -1]; //出勤状態が出勤終了以降シフト登録がシフト登録済以降

export const hdWorkTargetInput = TARGETINPUT_NONE;

/** Owner / Office > Report */
export const extListReport = [
  ['写メ日記数', '<%=$sum($hdList, hd => $isWrittenDiary(hd) ? 1 : 0)%>', false, { type: 0, equation: '' }],
  ['当日欠勤数', '<%= $hdList.filter(hd => hd.state1 == 6).length %>', false, { type: 0, equation: '' }],
];
export const hdWorkCount = `<% 
switch($hd.state["出勤状態"]) {
  case "お休み":
  case "当日欠勤":
    return 0;
  default:
    break;
}
if(0 < $hd.workMin){
  return 1;
} 
return 0;
%>`;
export const resvDuration = 1;
export const resvDurationList = ['60', '90', '120', '150'];
export const dailyTotal = '["売上","現金売上","カード売上","女子報酬","経費合計","求人広告費","特別収入","利益","貸付金","現金残","予約数","成約数","出勤数"]';
export const dailyItems = '指名,コース分数,オプション,ホテル,br,割引,イベント,延長,諸手当,着信人数';
export const showSales =
  '予約数,成約数,キャンセル数,悪質キャンセル数,キャンセル数(店事由),キャンセル数(女子事由),' +
  '料金,料金補正,割引額,女子報酬,報酬補正,特別手当１,特別手当２,雑費,major_0,major_1,major_6,経費合計,求人広告費,特別収入,利益,貸付金,現金残,カード数,カード手数料,新規予約数,新規成約数,新規予約のキャンセル数,新規予約の悪質キャンセル数,リピート数,リピート成約数,リピート予約のキャンセル数,リピート予約の悪質キャンセル数,フリー数,本指名数,ネット指名数,写真指名数,姫予約数,その他指名数,その他2指名数,有料オプション数,有料オプション料金,有料オプション報酬,resvDuration\r7,事前予約数,事前成約数,事前予約のキャンセル数,事前予約の悪質キャンセル数,当日予約数,当日成約数,当日予約のキャンセル数,当日予約の悪質キャンセル数,着信人数,新規着信人数,着信人数(不成立),着信人数(問い合わせ),出勤数,出勤時間';
export const shopHime = 0;
export const showHime =
  '予約数,成約数,キャンセル数,悪質キャンセル数,キャンセル数(女子事由),' +
  '料金,料金補正,女子報酬,報酬補正,特別手当１,特別手当２,雑費,求人広告費,利益,' +
  '新規予約数,新規成約数,新規予約のキャンセル数,新規予約の悪質キャンセル数,' +
  'リピート数,リピート成約数,リピート予約のキャンセル数,リピート予約の悪質キャンセル数,' +
  'フリー数,本指名数,ネット指名数,写真指名数,姫予約数,その他指名数,その他2指名数,' +
  '有料オプション数,有料オプション料金,有料オプション報酬,' +
  'resvDuration\r7,' +
  '事前予約数,事前成約数,事前予約のキャンセル数,事前予約の悪質キャンセル数,' +
  '当日予約数,当日成約数,当日予約のキャンセル数,当日予約の悪質キャンセル数,出勤数,出勤時間';

export const showMedia = '予約数,成約数,キャンセル数,悪質キャンセル数,' +
  '料金,女子報酬,媒体広告費,利益,カード数,カード手数料,' +
  'リピート数,リピート成約数,リピート予約のキャンセル数,リピート予約の悪質キャンセル数,' +
  'フリー数,本指名数,ネット指名数,写真指名数,姫予約数,その他指名数,その他2指名数,' +
  '有料オプション数,有料オプション料金,有料オプション報酬,' +
  'resvDuration\r7,' +
  '事前予約数,事前成約数,事前予約のキャンセル数,事前予約の悪質キャンセル数,' +
  '当日予約数,当日成約数,当日予約のキャンセル数,当日予約の悪質キャンセル数,着信人数(新規問い合わせ)';

export const showStaff = '着信受電数,予約数,成約数,キャンセル数,悪質キャンセル数,' +
  '料金,女子報酬,媒体広告費,利益,カード数,カード手数料,' +
  'リピート数,リピート成約数,リピート予約のキャンセル数,リピート予約の悪質キャンセル数,' +
  'フリー数,本指名数,ネット指名数,写真指名数,姫予約数,その他指名数,その他2指名数,' +
  '有料オプション数,有料オプション料金,有料オプション報酬,' +
  'resvDuration\r7,' +
  '事前予約数,事前成約数,事前予約のキャンセル数,事前予約の悪質キャンセル数,' +
  '当日予約数,当日成約数,当日予約のキャンセル数,当日予約の悪質キャンセル数,着信人数(新規問い合わせ)';

/** Office > Money */
export const collectType = COLLECT_TYPE_NONE;
export const recvType = RECV_TYPE_DRIVER_STAFF;
export const payType = PAY_TYPE_STAFF_DRIVER;
export const payTiming = PAY_TIMING_HIMEFIX;
export const recvTiming = RECV_TIMING_HIMEFIX_RESV_PAYVIEW;
export const recvMethod = RECV_METHOD_HAND;

/** Office > Pay */
export const spNameList = ['手当1(写メ日記)', '手当2'];

export const useOtherColumn = true;

export const vpdColumnList = [
  ['コース', '<%= $resv.course.pay %>'],
  ['指名', '<%= $resv.designate.pay %>'],
  ['延長', '<%= $resv.prolong.pay %>'],
  ['オプション', '<%= $resv.option.pay %>'],
];

export const displayTypes = {
  name: DISPLAY_NAME_REAL,
  office: DISPLAY_SHOW,
  staff: DISPLAY_SHOW,
};

export const miscSpecial = '<%\nconst result = {};\n\n' +
  'if ($hd && $hd.data["写メ日記"]) {\n  const val = $hd.data["写メ日記"];\n  ' +
  'const sp1Num = val.replace(/[^0-9]/g,' + ' "");\n  ' +
  'if(!isNaN(sp1Num)){\n     result.special1 = Number(sp1Num);\n  }\n}\n\n' +
  'const payTotal = $hd.payTotal + (result.special1||0);\n' +
  'result.misc = $numFloor((payTotal * $hd.z1) / 100, 1) * (-1);\nreturn result;\n%>';

export const varNames = ['雑費割合'];

export const varDefaults = [10];

export const bonus1 = '';

export const bonus2 = '';

/** Office > Resv */
export const incall = 0;
export const incallRound = 2;
export const mediaList = ['6', ['0', '不明', true, 0], ['1', '会員', true, 0], ['2', 'HP', true, 0], ['3', '検索エンジン', true, 0],
  ['4', 'ウェブサイト1', true, 0], ['5', 'ウェブサイト2', true, 0]];

export const vrlColumnListNoStore = [
  ['日付', '<%= $resv.date %>'],
  ['開始時間', '<%= $resv.timeStart %>'],
  ['店舗', '<%= $resv.shopName %>'],
  ['顧客', '<%= $resv.user.name %>'],
  ['女子', '<%= $resv.hsName %>'],
  ['指名', '<%= $resv.designate.label %>'],
  ['コース', '<%= $resv.courseLabel %>'],
  ['イベント', '<%= $resv.event.label %>'],
  ['割引', '<%= $resv.discount.label %>'],
  ['オプション', '<%= $resv.option.label %>'],
  ['ホテル', '<%= $resv.hotel.label %>'],
  ['支払い方法', '<%= !$isPriceCard($resv) ? "現金" : $resv.paymethod.value %>'],
  ['料金', '<%= $viewPrice($resv.priceTotal) %>'],
  ...(FEATURE_NET_RESV
    ? [['予約マーク', '<%= ($resv.callId ? "(電)" : "") + ($resv.props == 1 ? "(ﾈｯﾄ)" : "") + ($resv.userOffice.shopList.split( "," ).includes($resv.shopId) ? "" : "(店新)") %>']]
    : []),
  ['メモ', '<%= $resv.memo %>']
];

export const vrlColumnList = [
  ['日付', '<%= $resv.date %>'],
  ['開始時間', '<%= $resv.timeStart %>'],
  ['店舗', '<%= $resv.shopName %>'],
  ['顧客', '<%= $resv.user.name %>'],
  ['女子', '<%= $resv.hsName %>'],
  ['指名', '<%= $resv.designate.label %>'],
  ['コース', '<%= $resv.courseLabel %>'],
  ['イベント', '<%= $resv.event.label %>'],
  ['割引', '<%= $resv.discount.label %>'],
  ['オプション', '<%= $resv.option.label %>'],
  ['支払い方法', '<%= !$isPriceCard($resv) ? "現金" : $resv.paymethod.value %>'],
  ['料金', '<%= $viewPrice($resv.priceTotal) %>'],
  ...(FEATURE_NET_RESV
    ? [['予約マーク', '<%= ($resv.callId ? "(電)" : "") + ($resv.props == 1 ? "(ﾈｯﾄ)" : "") + ($resv.userOffice.shopList.split( "," ).includes($resv.shopId) ? "" : "(店新)") %>']]
    : []),
  ['メモ', '<%= $resv.memo %>']
];


export const stateListList = [
  // [1, 'ﾌﾟﾚｲ状況', 5, 2, [0, '予約', '予約', '#E6E6E6'], [1, '確電待ち', '電待', '#E6E6E6'], [2, '確電済み', '電済', '#E6E6E6'], [3, '開始', '開始', '#E6E6E6'], [4, '終了', '終了', '#E6E6E6'], [-1, '仮予約', '仮予約', '#E6E6E6'], [-2, 'SMS済', 'SMS済', '#E6E6E6'], [-3, '確電SMS済', '確SMS済', '#E6E6E6']],
  // [2, '女子状況', 4, 1, [0, '行移動', '行移', '#cccccc'], [1, '入室', '入室', '#BFBFBF'], [4, '終了', '終了', '#cccccc'], [2, '帰移動', '帰移動', '#cccccc'], [3, '済み', '済み', '#cccccc']]
  [1, 'ﾌﾟﾚｲ状況', 5, 2,
    ...(FEATURE_NET_RESV
      ? [[-10, '仮予約', '仮予約', '#E6E6E6', 1, 0]]
      : []),
    [0, '予約', '予約', '#E6E6E6', 1, 1],
    // [5, 'SMS済', 'SMS済', '#E6E6E6', 0, 0],
    [1, '確電待ち', '電待', '#E6E6E6', 1, 1],
    // [6, '確電SMS済', '電SMS済', '#E6E6E6', 0, 0],
    [2, '確電済み', '電済', '#E6E6E6', 1, 1],
    [3, '開始', '開始', '#E6E6E6', 1, 1],
    [4, '終了', '終了', '#E6E6E6', 1, 1],
  ],
  [2, '女子状況', 5, 1,
    // [4, '連絡前', '連絡前', '#cccccc', 1],
    // [5, '連絡済', '連絡済', '#cccccc', 1],
    [0, '行移動', '行移', '#cccccc', 1],
    [1, '入室', '入室', '#BFBFBF', 1],
    [2, '帰移動', '帰移', '#cccccc', 1],
    [3, '済み', '済み', '#cccccc', 1]
  ],
];

export const state1Default = 0;
export const state2Default = -1;

/**
 * 
 * @param {boolean | undefined} [full] 
 * @returns {setting.ViewItem}
 */
export const getDefaultViewItem = (full) => {
  const ret = {
    label: { type: 1, value: '' },
    content: {
      type: 1,
      value: ''
    },
    width: 1,
  };
  if (full) {
    ret.condition = {
      type: 0,
      value: '<%= true %>',
    };
    ret.font = {
      weight: 'normal',
      size: 14,
      color: '#000000',
    };
  }
  return ret;
};

/**
 * @type {setting.ViewItem[]}
 */
export const viewList = [
  {
    'label': {
      'type': 1,
      'value': '日時'
    },
    'content': {
      'type': 2,
      'value': '<%= $resv.date %> <%= $resv.timeStart %>-<%= $resv.timeEnd %>'
    },
    'width': 2
  },
  {
    'label': {
      'type': 1,
      'value': '店舗'
    },
    'content': {
      'type': 1,
      'value': 'shopName'
    },
    'width': 2
  },
  {
    'label': {
      'type': 1,
      'value': '女子'
    },
    'content': {
      'type': 1,
      'value': 'hime1Name'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '女子(3P)'
    },
    'content': {
      'type': 1,
      'value': 'hime2Name'
    },
    'condition': {
      'type': 1,
      'value': '<%= !!($resv.hime2Name) %>'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '使用P'
    },
    'content': {
      'type': 1,
      'value': 'pointUse'
    },
    'condition': {
      'type': 0,
      'value': '<%= $resv.shop?.ctrPoint == 1 %>'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '付与P'
    },
    'content': {
      'type': 1,
      'value': 'pointAdd'
    },
    'condition': {
      'type': 0,
      'value': '<%= $resv.shop?.ctrPoint == 1 %>'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '料金+ｶ手数料'
    },
    'content': {
      'type': 1,
      'value': 'priceTotalWithCardFee'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '釣銭用'
    },
    'content': {
      'type': 1,
      'value': 'moneyTemp'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '現金受領(客)'
    },
    'content': {
      'type': 1,
      'value': 'recvUserCash'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '現金受領(女)'
    },
    'content': {
      'type': 1,
      'value': 'recvHimeCash'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': 'コース'
    },
    'content': {
      'type': 1,
      'value': 'course'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '指名'
    },
    'content': {
      'type': 1,
      'value': 'designate'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '延長'
    },
    'content': {
      'type': 1,
      'value': 'prolong'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': 'イベント'
    },
    'content': {
      'type': 1,
      'value': 'event'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '待ち合わせ'
    },
    'content': {
      'type': 1,
      'value': 'waiting'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '交通費'
    },
    'content': {
      'type': 1,
      'value': 'transport'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': 'ホテル'
    },
    'content': {
      'type': 1,
      'value': 'hotel'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '部屋'
    },
    'content': {
      'type': 1,
      'value': 'playroom'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': 'オプション'
    },
    'content': {
      'type': 1,
      'value': 'option'
    },
    'width': 2
  },
  {
    'label': {
      'type': 1,
      'value': '割引'
    },
    'content': {
      'type': 1,
      'value': 'discount'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '支払い'
    },
    'content': {
      'type': 1,
      'value': 'paymethod'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '送りﾄﾞﾗｲﾊﾞｰ'
    },
    'content': {
      'type': 1,
      'value': 'driver1'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '迎えﾄﾞﾗｲﾊﾞｰ'
    },
    'content': {
      'type': 1,
      'value': 'driver2'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': 'ﾌﾟﾚｲ状況'
    },
    'content': {
      'type': 1,
      'value': 'state1'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '女子状況'
    },
    'content': {
      'type': 1,
      'value': 'state2'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '作成'
    },
    'content': {
      'type': 1,
      'value': 'staffCreate'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '最終更新'
    },
    'content': {
      'type': 1,
      'value': 'staffUpdate'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '受領'
    },
    'content': {
      'type': 1,
      'value': 'staffRecv'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': '媒体'
    },
    'content': {
      'type': 1,
      'value': 'firstMedia'
    },
    'width': 1
  },
  {
    'label': {
      'type': 1,
      'value': 'メモ'
    },
    'content': {
      'type': 1,
      'value': 'memo'
    },
    'width': 2
  }
];

/** @type {setting.DetailItem[]} */
export const schDetailView = [];

/**
 * @type {setting.ViewItem[]}
 */
const insert = (arr, index, newItem) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index)
];

const _hpViewList = [
  {
    label: { type: 1, value: '顧客名' },
    content: {
      type: 2,
      value: `<%
const cls = $resv.user.cls ? '(' + $resv.user.cls + ')' : ''
const phoneList = ($resv.user.phoneList || '').split(',');
const phone = phoneList[0] || '';
const phoneLast4 = 4 < phone.length ? phone.slice(-4) : '';
const phone4 = phoneLast4 ? '(' + phoneLast4 + ')' : ''
const normal = $resv.userOffice.cntNormal;
const cancel = $resv.userOffice.cntCancel + $resv.userOffice.cntCancelBad;
return $resv.user.name + cls + phone4 + ' / 成約' + normal + '回(ｷｬﾝｾﾙ' + cancel + '回)';
%>`
    },
    condition: {
      type: 0,
      value: '<%= !!$resv.user.name %>'
    },
    width: 2
  },
  {
    label: { type: 1, value: '' },
    content: {
      type: 2,
      value: `<%
const himeUserMemo = $resv.himeUser.memo.slice(0, 30).replace(/\\n/, ' ') + ($resv.himeUser.memo.length > 30 ? '...' : '');
const officeHimeMemo = $resv.userOffice.himeMemo.replace(/\\n/, ' ');
return [himeUserMemo, officeHimeMemo].filter(v => v != '').join(' / ');
%>`
    },
    condition: {
      type: 0,
      value: '<%= $resv.himeUser.memo != \'\' || $resv.userOffice.himeMemo != \'\' %>'
    },
    width: 2
  },
  {
    label: { type: 1, value: '前回ご利用' },
    content: {
      type: 2,
      value: '<%= $resvLastDate + \' / \' + $resvLast?.designate?.label + \' / \' + $viewPrice($resvLast?.priceTotal) %>'
    },
    condition: {
      type: 0,
      value: '<%= $resvLast?.id != null %>'
    },
    width: 2
  },
  ...viewList
]
  .filter(view => !['使用P', '付与P', '現金受領(女)', 'ﾌﾟﾚｲ状況', '女子状況', '作成', '最終更新', '受領', '媒体', 'メモ'].includes(view.label.value))
  .map(view => {
    switch (view.label.value) {
      case '料金+ｶ手数料':
        return {
          ...view,
          label: {
            ...view.label,
            value: '料金'
          }
        };
      case '現金受領(客)':
        return {
          ...view,
          label: {
            ...view.label,
            value: '現金受領'
          },
          width: 2,
        };
      case '支払い':
        return {
          ...view,
          label: {
            ...view.label,
            value: '支払い方法'
          }
        };
      default:
        break;
    }
    return view;
  });

const hotelIndex = _hpViewList.findIndex(view => view.label.value == '部屋');
export const hpViewList = insert(_hpViewList, hotelIndex + 1, {
  label: { type: 1, value: 'ホテルもしくは顧客住所' },
  content: {
    type: 1,
    value: 'hotelOrUserAddr'
  },
  width: 2
});

export const stateEnd = [4, 2];

/** Office > ResvAction */
export const nextAlarmId = '2';
export const alarmList = [
  ['', '', 1, -5, 'alarm2', 0, '0', 30],
  ['', '', 0, -10, 'alarm4', 0, '1', 30]
];

export const warnOnReplaceList = [
  ['<%\nvar MESSAGE = "予約時間が重なっています。このまま保存しますか？"\nvar timeStart = $resv.time || 0;\nvar duration = $resv.duration * 60 * 1000 || 0;\nvar timeEnd = timeStart+ duration;\n\nvar resvList = $getResvListDayHime($resv.hd).filter(resv => {\nvar resvId = resv?.id || "";\nif($resv.id == resvId){\nreturn false;\n}\nvar start = resv.time || 0;\nvar dura = resv.duration * 60 * 1000 || 0;\nvar end = start + dura;\n\nif(start <= timeStart && end <= timeStart){\nreturn false;\n}\nif(timeEnd<= start){\nreturn false;\n}\nreturn true;\n});\n\nif(0 < resvList.length){\nreturn MESSAGE;\n}\n%>', 2],
  [`<%
// 確認する予約インターバル（分）
var INTERVAL = 10;

var newStart = $resv.time || 0;
var newDuration = $resv.duration * 60 * 1000 || 0;
var newEnd = newStart+ newDuration;
var intervalMillis = INTERVAL * 60 * 1000;
var withBefore = false;
var withAfter = false;
var beforeInterval = 0;
var afterInterval = 0;

$getResvListDayHime($resv.hd).forEach(resv => {
  var resvId = resv?.id || "";
  if($resv.id != resvId) {
    var start = resv.time || 0;
    var duration = resv.duration * 60 * 1000 || 0;
    var end = start + duration;

    if (newStart >= end && newStart-end < intervalMillis) { 
      withBefore = true;
      beforeInterval = (newStart - end)/1000/60;
    }
    if (newEnd <= start && start-newEnd  < intervalMillis) { 
      withAfter = true;
      afterInterval = (start - newEnd)/1000/60;
    }
  }
});

if (withBefore || withAfter) {
  var msgHeader = "";
  var intervalMsg = "";
  if (withBefore && !withAfter) {
    msgHeader = "前";
    intervalMsg = \`\${beforeInterval}分\`;
  }
  else if (!withBefore && withAfter) {
    msgHeader = "後";
    intervalMsg = \`\${afterInterval}分\`;
  }
  else {
    msgHeader = "前と後";
    intervalMsg = \`\${beforeInterval}分と\${afterInterval}分\`;
  }

  return \`\${msgHeader}の予約とのインターバルが\${INTERVAL}分未満(\${intervalMsg})になっています。このまま保存しますか？\`;
}
%>`, 2]
];

/** 報酬確定時の警告 @type {[string, number][]} */
export const warnOnFixList = [];

/** Office > Urc */
export const hisColumnList = [
  ['日付', '<%= $resv.date %>'],
  ['店舗', '<%= $resv.shopName %>'],
  ['女子', '<%= $resv.hsName %>'],
  ['指名', '<%= $resv.designate.label %>'],
  ['コース', '<%= $resv.courseLabel %>'],
  ['料金', '<%= $viewPrice($resv.priceTotal) %>'],
];

export const userBgColor = {
  bgColor: '<%if($user.cls == \'0\'){ return \'#FFFFFF\'}\n' +
    'if($user.cls == \'1\'){ return \'#80BFFF\'}\n' +
    'if($user.cls == \'2\'){ return \'#FFD5AA\'}\n' +
    'if($user.cls == \'3\'){ return \'#D5D5FF\'}\n' +
    'if($user.cls == \'4\'){ return \'#E06666\'}\n%>',
  clsBgColor: [
    { id: '0', label: '一般', color: '#FFFFFF' },
    { id: '1', label: '会員', color: '#80BFFF' },
    { id: '2', label: '常連', color: '#FFD5AA' },
    { id: '3', label: 'VIP', color: '#D5D5FF' },
    { id: '4', label: 'NG', color: '#E06666' }
  ],
};

export const connTypeBgColor = [
  { id: '0', color: '#FFFFFF' },
  { id: '1', color: '#FFFFFF' },
  { id: '2', color: '#FFFFFF' },
  { id: '3', color: '#FFFFFF' },
  { id: '4', color: '#FFFFFF' },
  { id: '5', color: '#FFFFFF' },
  { id: '6', color: '#FFFFFF' },
  { id: '7', color: '#FFFFFF' },
];


/** Office > Sb */
export const hdWorkCountSb = '<%=$getWorkNum($hd)%>';

export const varNamesSb = ['給与比', '出勤ごと'];

export const varDefaultsSb = [0, 1000];
export const varTypesSb = [1, 1];

export const conHimeDay = '<%= $isWorkForQC($hd) ? $hd.hime.qc.x2 : 0 %>';

export const expHimeDay = '<%= Math.round($calcPayForQC($hd) * $hd.hime.qc.x1 / 100) %>';//給与の10%を求人広告費に割り当てる

export const expHimeMonth = '<%=$totalQC %>';

export const expMonth = '<%=$totalQC %>';

export const calcPayOld = '<%= $hd.payTotal - $hd.paySpecial1 - $hd.paySpecial2 - $hd.paySpecial3 - $hd.paySpecial4 - $hd.payCorrect %>';
export const calcPay = '<%= $hd.payTotal - $hd.payMisc - $hd.paySpecial1 - $hd.paySpecial2 - $hd.paySpecial3 - $hd.paySpecial4 - $hd.payCorrect %>';

export const sbBasicType = SBTYPE_SPEC;
export const sbBasicOldLabels = ['求人広告費', '求人広告会社', '求人広告担当者', '報酬分広告費', '顧問料'];
export const sbBasicNewLabels = ['特別経費', '大分類', '小分類', '指標A', '指標B'];

/** Office > resvPoint */
export const addPercent = '';
export const addCalc = '';
export const useMaxCalc = '';
export const useUnit = '100';
export const expireDate = '';
export const pointRate = 1;
export const useTax = '0';
export const usePriceCorrect = '0';
export const usePriceCardFee = '0';
export const useSetting = true;
export const useResvEnd = '1';

/** Office > Call */
export const typeList = [9,
  [1, '予約', true], [2, '不成立', true], [3, '問い合わせ', true],
  [4, '確認', true], [5, 'キャンセル連絡', true], [6, 'クレーム', true],
  [7, '業務連絡', true], [8, '求人', true],
  [127, 'その他', true]
];

export const extListList = [[1, '折り返し', 4, true, [1, '必要', true], [2, '不要', true], [3, '済', true]]];

export const vpModeTake = 0; //複数PCの場合のみ

export const connTypeNameList = [
  '未設定',
  '一般',
  '会員',
  '特別',
  '女子',
  '求人',
  '業務用',
  'その他'
];

/**
 * Office > Schedule
 * @type {setting.Schedule["resvTexts"]}
 */
export const resvText = [
  '5',
  ['時間の長さ', '0'],
  ['顧客名', '1'],
  ['ホテルもしくは顧客住所', '0'],
  ['部屋', '1'],
  ['料金総額＋カード手数料', '0'],
  ['釣銭用前渡金', '0']
];

export const resvStateActTime = [];//ステータス変更時に現在時刻をセットする条件

export const resvStateActBlinkList = [
  ['1', '1', '1', '-45', '#FF0000', '0'],
];

export const resvBgList = [
  ['<%= $isResvEnd($resv) %>', '#e2e2e2'],
  ['', '', '', '#CCF2F4'],
  ['', '', '', '#FFFF89'],
  ['', '', '', '#BFFF7F'],
  ['', '', '', '#ffd5d5'],
];

export const resvBgList20240207 = [
  ['<%= $resv.shopName == "店舗名" && $isResvEnd($resv) %>', '#BFBFBF'],
  ['<%= $isResvEnd($resv) %>', '#e2e2e2'],
  ['', '', '', '#CCF2F4', 1],
  ['', '', '', '#FFFF89', 1],
  ['', '', '', '#BFFF7F', 1],
  ['', '', '', '#ffd5d5', 1],
];

export const resvMarkList = [
  ['', '支払い', 'カード', 'ｶｰﾄﾞ', '#80FF80'],
  ['', '指名', '本指名', '本', '#FFFF80'],
  ['', '指名', '写真指名', '写真', '#FFD5D5'],
  ['', '指名', 'ネット指名', 'ﾈｯﾄ', '#FFD5D5'],
];

export const resvMarkList20240207 = [
  ['', '支払い', 'カード', 'ｶｰﾄﾞ', '#80FF80', 0],
  ['', '指名', '本指名', '本', '#FFFF80', 1],
  ['', '指名', '写真指名', '写真', '#FFD5D5', 1],
  ['', '指名', 'ネット指名', 'ﾈｯﾄ', '#FFD5D5', 1],
];

export const resvMarkList20250404 = [
  ['', '支払い', 'カード', 'ｶｰﾄﾞ', '#80FF80', 2],
  ['', '指名', '本指', '本', '#FFFF80', 2],
  ['', '指名', '写真', '写真', '#FFD5D5', 2],
  ['', '指名', 'ネット', 'ﾈｯﾄ', '#FFD5D5', 2],
  ['', '指名', '姫', '姫', '$FFD5DS', 2]
];

export const headerTemplate = `
予約数:<span class="schedule-count"><%= $resvCount %></span>本
／
出勤数:<span class="schedule-count"><%= $hdCount %></span>人
(報酬確定済:<span class="schedule-count"><%= $hdFixedCount %></span>人)
`.trim();

export const sdDoneView = 1;
export const sdMoneyThreshold = 100000;

export const hdMarkList = [
  ['報酬:<%= $viewPrice(($hd.payTotal == null || $hd.payTotal == -1) ? $sum($getResvListDayHime($hd), resv => $choosePayTotal(resv, $hd.himeId)) : $hd.payTotal) %>', '#AAFFFF']
];

export const hdBgList = [
  ['1', '-2', '#FFE2E2'],
  ['<%= $getResvListDayHime($hd).some(resv => resv.state2?.label == "接客") %>', '#E1F2FB']
];

export const hdStateActBlink = [
  ['2', '1', '1', '-60', '#FFFF89'],
];

/** Office > Shop */
export const taxCalc = '';
/** 2026/1/4 の前のデフォルト消費税 (全料金の10%) */
export const taxCalcOld = '<%= ($resv.priceTotalMissingTax) * 10 / 100 %>';

export const cardFeeProps = 7;

export const use3p = 1;

export const useDriver = 1;

export const RANK_FALLBACK_TO_FIRST = 0;
export const RANK_FALLBACK_TO_PREV = 1;
export const rankFallbackMode = RANK_FALLBACK_TO_PREV;

export const itemList = [
  {
    dataIdx: 1,
    label: 'コース',
    props: 6, //空白許可しない・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 60,
        id: '0',
        name: '60分',
        payCalc: '',
        payList: [10000],
        payType: 0,
        priceCalc: '',
        priceList: [18000],
        priceType: 0
      },
      {
        duration: 90,
        id: '1',
        name: '90分',
        payCalc: '',
        payList: [14000],
        payType: 0,
        priceCalc: '',
        priceList: [25000],
        priceType: 0
      },
      {
        duration: 120,
        id: '2',
        name: '120分',
        payCalc: '',
        payList: [18000],
        payType: 0,
        priceCalc: '',
        priceList: [36000],
        priceType: 0
      },
      {
        duration: 150,
        id: '3',
        name: '150分',
        payCalc: '',
        payList: [21000],
        payType: 0,
        priceCalc: '',
        priceList: [40000],
        priceType: 0
      },
      {
        duration: 50,
        id: '4',
        name: 'お試しコース',
        payCalc: '',
        payList: [6000, 8000, 10000],
        payType: 0,
        priceCalc: '',
        priceList: [10000, 12000, 14000],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_COURSE,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
  {
    dataIdx: 2,
    label: '指名',
    props: 6, //空白許可しない・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        ext1: ResvItem.DESIGNATE_FREE,
        id: '0',
        name: 'ﾌﾘｰ',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
      {
        duration: 0,
        ext1: ResvItem.DESIGNATE_HON,
        id: '1',
        name: '本指名',
        payCalc: '',
        payList: [500, 1000, 1500],
        payType: 0,
        priceCalc: '',
        priceList: [1000, 2000, 3000],
        priceType: 0
      },
      {
        duration: 0,
        ext1: ResvItem.DESIGNATE_PHOTO,
        id: '2',
        name: '写真指名',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [500],
        priceType: 0
      },
      {
        duration: 0,
        ext1: ResvItem.DESIGNATE_NET,
        id: '3',
        name: 'ﾈｯﾄ指名',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_DESIGNATE,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
  {
    dataIdx: 3,
    label: '延長',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        id: '0',
        name: '延長なし',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
      {
        duration: 10,
        id: '1',
        name: '10分',
        payCalc: '',
        payList: [500],
        payType: 0,
        priceCalc: '',
        priceList: [1000],
        priceType: 0
      },
      {
        duration: 20,
        id: '2',
        name: '20分',
        payCalc: '',
        payList: [1000],
        payType: 0,
        priceCalc: '',
        priceList: [1500],
        priceType: 0
      },
      {
        duration: 30,
        id: '3',
        name: '30分',
        payCalc: '',
        payList: [1500],
        payType: 0,
        priceCalc: '',
        priceList: [2000],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_PROLONG,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
  {
    dataIdx: 4,
    label: 'イベント',
    props: 7, //空白許可のみ
    selectList: [
      {
        duration: 0,
        id: '0',
        name: '記念イベント',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [-2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '1',
        name: 'ご新規限定コース',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [-2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '2',
        name: '会員限定コース',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [-4000],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 0,
    type: ResvItem.TYPE_EVENT,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
  {
    dataIdx: 5,
    label: '待ち合わせ',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        id: '0',
        name: '自宅',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
      {
        duration: 0,
        id: '1',
        name: '待ち合わせ場所A',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
      {
        duration: 0,
        id: '2',
        name: '待ち合わせ場所B',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_WAITING,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
  {
    dataIdx: 6,
    label: '交通費',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        id: '0',
        name: '交通費なし',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0
      },
      {
        duration: 0,
        id: '1',
        name: '交通費1000円',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [1000],
        priceType: 0
      },
      {
        duration: 0,
        id: '2',
        name: '交通費2000円',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [2000],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_TRNSPORT,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
  {
    dataIdx: 7,
    label: 'ホテル',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        id: '0',
        name: '自宅',
        priceList: [0],
        ext2: ''
      },
      {
        duration: 0,
        id: '1',
        name: 'ホテルA',
        priceList: [1000],
        ext2: ''
      },
      {
        duration: 0,
        id: '2',
        name: 'ホテルB',
        priceList: [1000],
        ext2: ''
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_HOTEL,
    viewType: ResvItem.VIEWTYPE_SELECT_EDIT,
    viewWidth: 1
  },
  {
    dataIdx: 8,
    label: '部屋',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_PLAYROOM,
    viewType: ResvItem.VIEWTYPE_TEXT,
    viewWidth: 1
  },
  {
    dataIdx: 9,
    label: 'オプション',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        id: '0',
        name: 'ローター',
        payCalc: '',
        payList: [500],
        payType: 0,
        priceCalc: '',
        priceList: [1000],
        priceType: 0
      },
      {
        duration: 0,
        id: '1',
        name: 'パンスト',
        payCalc: '',
        payList: [500],
        payType: 0,
        priceCalc: '',
        priceList: [1000],
        priceType: 0
      },
      {
        duration: 0,
        id: '2',
        name: '<br>',
        payCalc: 0,
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0,
      },
      {
        duration: 0,
        id: '3',
        name: 'コスプレ',
        payCalc: '',
        payList: [1000],
        payType: 0,
        priceCalc: '',
        priceList: [2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '4',
        name: 'バイブ',
        payCalc: '',
        payList: [1000],
        payType: 0,
        priceCalc: '',
        priceList: [2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '5',
        name: '<br>',
        payCalc: 0,
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0,
      },
      {
        duration: 0,
        id: '6',
        name: 'オナニー',
        payCalc: '',
        payList: [1000],
        payType: 0,
        priceCalc: '',
        priceList: [2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '7',
        name: '写真撮影',
        payCalc: '',
        payList: [1000],
        payType: 0,
        priceCalc: '',
        priceList: [2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '8',
        name: '<br>',
        payCalc: 0,
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0,
      },
      {
        duration: 0,
        id: '9',
        name: '聖水',
        payCalc: '',
        payList: [1500],
        payType: 0,
        priceCalc: '',
        priceList: [3000],
        priceType: 0
      },
      {
        duration: 0,
        id: 'A',
        name: 'ごっくん',
        payCalc: '',
        payList: [1500],
        payType: 0,
        priceCalc: '',
        priceList: [3000],
        priceType: 0
      },
      {
        duration: 0,
        id: 'B',
        name: '顔射',
        payCalc: '',
        payList: [1500],
        payType: 0,
        priceCalc: '',
        priceList: [3000],
        priceType: 0
      },
      {
        duration: 0,
        id: 'C',
        name: '<br>',
        payCalc: 0,
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0,
      },
      {
        duration: 0,
        id: 'D',
        name: 'AF',
        payCalc: '',
        payList: [3500],
        payType: 0,
        priceCalc: '',
        priceList: [7000],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_OPTION,
    viewType: ResvItem.VIEWTYPE_CHECKBOX,
    viewWidth: 2
  },
  {
    dataIdx: 10,
    label: '割引',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        duration: 0,
        id: '0',
        name: '新規割',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [-3000],
        priceType: 0
      },
      {
        duration: 0,
        id: '1',
        name: 'ネット割引',
        payCalc: '',
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [-2000],
        priceType: 0
      },
      {
        duration: 0,
        id: '2',
        name: '<br>',
        payCalc: 0,
        payList: [0],
        payType: 0,
        priceCalc: '',
        priceList: [0],
        priceType: 0,
      },
      {
        duration: 0,
        id: '3',
        name: '割引券',
        payCalc: '',
        payList: [-1000],
        payType: 0,
        priceCalc: '',
        priceList: [-1000],
        priceType: 0
      },
      {
        duration: 0,
        id: '4',
        name: '指名料無料',
        payCalc: '',
        payList: [-500],
        payType: 0,
        priceCalc: '',
        priceList: [-500],
        priceType: 0
      },
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_DISCOUNT,
    viewType: ResvItem.VIEWTYPE_CHECKBOX,
    viewWidth: 2
  },
  {
    dataIdx: 11,
    label: '支払い',
    props: 7, //空白許可する・カード手数料あり・ポイントあり
    selectList: [
      {
        id: '0',
        name: 'カード(手数料10%)',
        priceList: [0],
        priceType: 0,
        ext1: 10
      }
    ],
    selectListInvalid: [],
    showType: 1,
    type: ResvItem.TYPE_PAYMETHOD,
    viewType: ResvItem.VIEWTYPE_SELECT,
    viewWidth: 1
  },
];

export const tplList = [
  {
    'type': 2, 'name': '予約連絡', 'subject': '予約連絡', 'body': '予約が入りました。\n\n■日時 ： <%= $resv.date %> <%= $resv.timeStart %>-<%= $resv.timeEnd %>\n■店舗 ： <%= $resv.shopName %>\n\n■料金合計 ： <%= $viewPrice($resv.priceTotalWithBurden) %>\n\n■ホテル ： <%= $resv.hotelOrUserAddr %> <%= $resv.playroom.value %>\n■地図 ： <%= $resv.hotelOrUserMap %>\n\n■コース ： <%= $resv.course.value %>\n■指名 ： <%= $resv.designate.value %>\n■オプション ： <%= $resv.option.value %>\n■予約メモ ： <%= $resv.memo %>\n\n■送りドライバー：<%= $resv.driver1.name %>\n■迎えドライバー ：<%= $resv.driver2.name %>\n\n【お客様情報】\n\n■名前 ： <%= $resv.user.name %>（<%= $resv.user.nameRead %>）'
      + '\n■前回利用 ： <%= $resvLast?.date %> <%= $resvLast?.designate?.value %> <%= $viewPrice($resvLast?.priceTotal) %>'
      + '\n■メモ ： <%= [$resv.userOffice.ngMemo, $resv.userOffice.himeMemo, $resv.himeUser?.memo, $resv.userOffice.memo, $resv.user.shMemo].filter(memo => !!memo).map(memo => memo.replace(/\\n/g, " ").trim()).join("\\n・").substring(0, 600) %>'
      + '\n\nよろしくお願いいたします。'
  },
  { 'type': 6, 'name': '予約連絡', 'subject': '', 'body': '<%= $resv.driver1.name %>さん\n\n次の予約情報です。\n\n・女子：<%= $resv.hsName %>\n\n・開始時刻：<%= $resv.timeStart %>\n\n・ホテル：<%= $resv.hotelOrUserAddr %>\n\n・地図：<%= $resv.hotelOrUserMap %>\n\n・部屋番号：<%= $resv.playroom.value %>\n\nよろしくお願いします。\n\n※時間に大きく遅れる場合は下記に連絡してください\n090-xxxx-xxxx' },
  { 'type': 7, 'name': '予約連絡', 'subject': '', 'body': '<%= $resv.driver1.name %>さん\n\n次の予約情報です。\n\n・女子：<%= $resv.hsName %>\n\n・終了予定時刻：<%= $resv.timeEnd %>\n\n・ホテル：<%= $resv.hotelOrUserAddr %>\n\n・地図：<%= $resv.hotelOrUserMap %>\n\n・部屋番号：<%= $resv.playroom.value %>\n\nよろしくお願いします。\n\n※時間に大きく遅れる場合は下記に連絡してください\n090-xxxx-xxxx' },
  { 'type': 8, 'name': '報酬明細', 'subject': '', 'body': '<%= $hd.hime.name %>さん、お仕事お疲れ様でした。\n\n【報酬】\n合計：<%= $viewPrice($hd.payTotal) %>\n本数：<%= $getResvListDayHime($hd).length %>本 \n\n【出勤情報】\n日付：<%= $hd.vDate %>\n出勤時間：<%= $hd.vWorkStart %>～<%= $hd.vWorkEnd %>\n\n詳細は下記URLよりご確認ください。\n<%= $hd.vUrl %>' },
  { 'type': 4, 'name': '予約確認', 'subject': '', 'body': '<%= $resv.user.name %>様のご予約の確認です。\n■日時 ： <%= $resv.date %> <%= $resv.timeStart %>-<%= $resv.timeEnd %>\n■店舗 ： <%= $resv.shopName %>\n■女子 ： <%= $resv.hsName %>\n■ホテル ： <%= $resv.hotelOrUserAddr %> <%= $resv.playroom.value %>\n■地図 ： <%= $resv.hotelOrUserMap %>\n■料金 ： <%= $viewPrice($resv.priceTotalWithBurden) %>\nよろしくお願いいたします。' },
  { 'type': 4, 'name': '予約確認（メンズエステ用）', 'subject': '', 'body': '<%= $resv.user.name %>様のご予約の確認です。\n■日時 ： <%= $resv.date %> <%= $resv.timeStart %>-<%= $resv.timeEnd %>\n■店舗 ： <%= $resv.shopName %>\n■女子 ： <%= $resv.hsName %>\n■場所 ： <%= $resv.hd.workTargetAddress1 %>\n■地図 ： <%= $resv.hd.workTargetAddress2 %>\n■料金 ： <%= $viewPrice($resv.priceTotalWithBurden) %>\nよろしくお願いいたします。' },
  { 'type': 9, 'name': '出勤情報', 'subject': '', 'body': '本日の出勤時間をご連絡します。\n\n出勤開始時間：<%= $hd.vWorkStart %>\n出勤終了時間：<%= $hd.vWorkEnd %>\n\n出勤場所：<%= $hd.workTargetPlace %>\n出勤場所の住所：<%= $hd.workTargetAddress1 %>\n出勤場所の地図：<%= $hd.workTargetAddress2 %>' },
  { 'type': 4, 'name': '営業(来店後)', 'showOnMenu': false, 'subject': '', 'body': '<%= $resv.user.name %>様、本日は<%= $resv.shopName %>をご利用頂き、誠にありがとうございました。こちらのSMSは次回使える1000円分のクーポンとなります。次回のご利用お待ちしております！' },
  { 'type': 5, 'name': '営業(会員)', 'subject': '', 'body': '会員様限定の特別割引実施中！この機会にぜひ遊びに来てくださいね！' },
  { 'type': 5, 'name': '営業(特別)', 'subject': '', 'body': 'こちらのSMSが届いたお客様限定で、本日限り5000円OFFでご利用いただけます！出勤確認お願いします！ https://demo.jp' }];

export const useMajorMax = 31;
export const exceptMajorIds = [30, 31];

export const clsMajorOrder = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31';
export const clsMajorNameList = [
  'ドライバー',
  'スタッフ',
  '交通費',
  '燃料費',
  'ホテル代',
  '女子業務経費',
  '宣伝広告費',
  '消耗品購入費',
  '備品購入費(10万円未満)',
  '備品購入費(10万円以上)',
  '外注費',
  '修繕費',
  '洗濯清掃費',
  'サービス利用料',
  '通信費',
  '水道光熱費',
  '賃料',
  '福利厚生費',
  '接待交際費',
  '税金・保険料',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  'その他',
  '特別収入',
  '貸付金',
];

/** Office > Expense */
export const clsMajorUse = '3759144959';//全選択

export const clsSmallList = [
  ['1', ['0', '', 0, 0]], //ドライバー

  ['3', ['0', 'スタッフA', 0, 0, 0], ['1', 'スタッフB', 0, 0, 0], ['2', 'スタッフC', 0, 0, 0]], //スタッフ

  ['3', ['0', '女子移動交通費', 0, 0, 0], ['1', '高速道路代', 0, 0, 0], ['2', '面接交通費', 0, 0, 0]], //交通費

  ['2', ['0', 'ガソリン代', 0, 0, 0], ['1', 'その他', 0, 0, 0]], //燃料費

  ['3', ['0', '◯◯市内', 0, 0, 0], ['1', 'XX県内', 0, 0, 0], ['2', '県外', 0, 0, 0]], //ホテル代

  ['3', ['0', '検査代', 0, 0, 0], ['1', '撮影代', 0, 0, 0], ['2', '研修費', 0, 0, 0]], //女子業務経費

  ['4', ['1', '広告掲載費(求人用)', 1, 1, 0], ['3', '広告運用費', 1, 1, 0]], //広告宣伝費

  ['4', ['0', '日用品', 0, 0, 0], ['1', '衛生用品', 0, 0, 0], ['2', '小型玩具代', 0, 0, 0], ['3', '事務用品', 0, 0, 0]], //消耗品購入費

  ['7', ['0', '衣装代', 0, 0, 0], ['1', '玩具代', 0, 0, 0], ['2', '新聞図書費', 0, 0, 0],
    ['3', '電子機器類', 0, 0, 0], ['4', 'ソフトウェア', 0, 0, 0], ['5', '家具類', 0, 0, 0], ['6', '家電類', 0, 0, 0]], //備品購入費(10万円未満)

  ['3', ['0', '電子機器類(高額)', 1, 0, 0], ['1', 'ソフトウェア(高額)', 1, 0, 0], ['2', '高額備品類', 1, 0, 0]],  //備品購入費(10万円以上)

  ['4', ['0', 'HP制作費', 1, 1, 0], ['1', 'ソフトウェア制作費', 1, 1, 0], ['2', '工事費', 1, 1, 0], ['3', '作業委託費', 1, 1, 0]], //外注費

  ['5', ['0', '機械修理費', 1, 1, 0], ['1', '設備修理費', 1, 1, 0], ['2', '建物修理費', 1, 1, 0], ['3', '車両整備費', 1, 1, 0], ['4', '車検費', 1, 1, 0]], //修繕費

  ['3', ['0', 'クリーニング代', 0, 0, 0], ['1', '清掃代', 0, 0, 0], ['2', 'ゴミ処理代', 0, 0, 0]], //洗濯清掃費

  ['4', ['0', 'HP管理費', 1, 1, 0], ['1', '管理システム利用料', 1, 1, 0], ['2', 'ウェブサービス利用料', 1, 1, 0], ['3', '設備保守費', 1, 1, 0]], //サービス利用料

  ['3', ['0', '電話料金', 1, 1, 0], ['1', 'インターネット料金', 1, 1, 0], ['2', '郵便切手代', 0, 0, 0]], //通信費

  ['3', ['0', '電気代', 1, 1, 0], ['1', 'ガス代', 1, 1, 0], ['2', '水道代', 1, 1, 0]], //水道光熱費

  ['3', ['0', '事務所賃料', 1, 1, 0], ['1', '待機所賃料', 1, 1, 0], ['2', '駐車場代', 1, 1, 0]], //賃料

  ['4', ['0', '通勤費', 1, 1, 0], ['1', '寮運営費', 1, 1, 0], ['2', '祝い金', 1, 1, 0], ['3', '医薬品購入費', 0, 0, 0]], //福利厚生費

  ['2', ['0', '飲食費', 0, 0, 0], ['1', '贈答品', 0, 0, 0]], //接待交際費

  ['2', ['0', '税金', 1, 1, 0], ['1', '保険料', 1, 1, 0]], //税金・保険料

  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],
  ['1', ['0', '', 0, 0, 0]],

  ['2', ['0', '支払手数料', 1, 0, 0], ['1', '過不足調整金', 1, 0, 0]], //その他
  ['3', ['0', '雑収入', 0, 0, 0], ['1', '雑収入', 1, 0, 0], ['2', '受取利息', 1, 0, 0]], //特別収入
  ['3', ['0', '短期貸付金', 0, 0, 0], ['1', '長期買付金', 0, 0, 0], ['2', '貸付返済金', 1, 0, 0]], //貸付金
];

/** Owner > officePrevFraud */
export const officePrevFraud = {
  msgSendResv: 1,
  msgSendFix: 1,
  msgMethod: 3,
  himeMustPhoneMobile: 0,
};

export const hpResvText = [
  '10',
  ['時間の長さ', '0'],
  ['顧客名', '1'],
  ['顧客会員番号', '0'],
  ['顧客電話番号下4桁', '0'],
  ['顧客の利用回数', '0'],
  ['女子の顧客メモ', '0'],
  ['女子向けメモ', '0'],
  ['ホテル', '1'],
  ['部屋', '0'],
  ['ホテルもしくは顧客住所', '0'],
  ['迎えﾄﾞﾗｲﾊﾞｰ', '0'],
  ['店舗名', '1'],
  ['コース', '0'],
  ['延長', '0'],
  ['指名', '0'],
  ['オプション', '0'],
  ['イベント', '0'],
  ['料金総額＋カード手数料', '0'],
  ['支払い方法', '0']
];

/** Office > actResvList */

const filterPlayState = (normalizedPlayState, targetLabel, defaultValue) => {
  for (const id of normalizedPlayState.allIds) {
    if (normalizedPlayState.byId[id].label === targetLabel) {
      return id;
    }
  }
  return defaultValue;
};

export const createActResvListDefaultValue = (normalizedPlayState, defaultStateValue = null, allNull = false) => {
  const _f = (k) => filterPlayState(normalizedPlayState, k, defaultStateValue);

  /** @type {model.Condition} */
  const condition = {
    shopIdList: [],
    state1List: [],
    timeCreateDiffMin: 90
  };

  /** @type {model.ActResv} */
  const actResvUrge1 = {
    type: TYPE_TIME,
    condition: {
      ...condition,
      state1List: allNull ? [_f('確電待ち')] : [],
    },
    action: {
      state1: _f('確電SMS'),
      smsTpl: `$shopNameです。

確認のご連絡をお待ちしております。
03-XXXX-XXXX
      
ご予約時刻：$time`,
      smsMaxLength: 70,
      smsType: 1
    },
    timeMinuteStart: 50,
    timeMinuteEnd: 0
  };

  /** @type {model.ActResv} */
  const actResvWait1 = {
    type: TYPE_TIME,
    condition: {
      ...condition,
      state1List: allNull ? [_f('予約'), _f('SMS済')].filter(x => x != null) : [],
    },
    action: {
      state1: _f('確電待ち'),
      smsTpl: '',
      smsMaxLength: 0,
      smsType: 0
    },
    timeMinuteStart: 60,
    timeMinuteEnd: 0
  };

  /** @type {model.ActResv} */
  const actResvInCall1 = {
    type: TYPE_CALL,
    condition: {
      ...condition,
      state1List: allNull ? [_f('予約'), _f('SMS済'), _f('確電待ち'), _f('確電SMS済')].filter(x => x != null) : [],
    },
    action: {
      state1: _f('確電済み'),
      smsTpl: '',
      smsMaxLength: 0,
      smsType: 0
    },
    timeMinuteStart: 90,
    timeMinuteEnd: 0
  };

  /** @type {setting.ActResvList} */
  const actResvList = {
    urge: actResvUrge1,
    wait: actResvWait1,
    inCall: actResvInCall1,
    /** @type {model.SmsSend} */
    smsSend: {
      disabled: false,
      state1List: [_f('予約')].filter(x => x != null),
      toState1: _f('SMS済'),
    },
    /** @type {model.LineSend} */
    lineSend: {
      disabled: false,
      state2List: [-1],
      toState2: null,
    },
  };
  return actResvList;
};


export const hdEndType = [
  [1], // default 
  [1, 'Up', 'Up', '#FF5F7E', true, 0],
  [2, '受付終了', '受', '#29c6ff', true, 60],
  [3, '', '', '#cccccc', false, 0],
  [4, '', '', '#cccccc', false, 0],
  [5, '', '', '#cccccc', false, 0],
  [6, '', '', '#cccccc', false, 0],
  [7, '', '', '#cccccc', false, 0],
  [8, '', '', '#cccccc', false, 0],
];

export const ngOpView = 1;

export const useHimeMemo3 = 0;

export const showHimePageWorkPlace = 1;

/** 女子の連絡手順の優先度 */
export const himeContactPriority = [
  HIME_CONTACT_LINE_SIMPLE,
  HIME_CONTACT_LINE,
  HIME_CONTACT_MAIL,
];

export const smsTextTpl = `<%= $resv.user.name %>様
ネット予約を承りました。
■日時 ： <%= $resv.date %> <%= $resv.timeStart %>-<%= $resv.timeEnd %>
■女子 ： <%= $resv.hsName %>
■料金 ： <%= $viewPrice($resv.priceTotalWithBurden) %>
`;

export const resvCreateText = '予約を承りました。お客様のご希望に添えない場合（希望日時・ご利用コース・女子など）は、SMSまたはお電話でご連絡いたします。あらかじめご了承ください。';

export const shortcuts = {
  closeModal: 'Escape'
};